/*
 * Verfuegbarkeitsmeldung („Benachrichtigen, wenn wieder verfuegbar", intern
 * Back2Stock) – ersetzt die App Notify Me!. Markup: snippets/acl-restock.liquid,
 * Briefing: BRIEFING-VERFUEGBARKEIT.md.
 *
 * - Knopf je Produktformular: sichtbar, solange die gewaehlte Variante
 *   ausverkauft ist. Variante aus `variantChange` am Produkt-Container von
 *   theme.js (kommt auch ohne Variante, wenn die Kombination fehlt), sonst aus
 *   `variant:change` (Impulse) bzw. `variant:changed` (Sonder-PDPs) am document.
 * - Dialog (theme.Modals): Anmeldung direkt an Klaviyos Client-API
 *   (back-in-stock-subscriptions, Variante `$shopify:::$default:::<id>`), danach
 *   die Sprache als Profil-Eigenschaft `sprache` und als Profilfeld `locale`
 *   (zwei Buchstaben, fuer Klaviyos Uebersetzungen) wie bei der Wunschliste und
 *   das Abo der Newsletter-Liste. Kein Haekchen: jede Anmeldung kommt in den
 *   Newsletter (Daniel und David, 02.11.2026), Single Opt-in, die Einwilligung
 *   gilt in Klaviyo fuers ganze Profil. Ein Satz direkt ueber dem Knopf sagt
 *   das; ohne diesen sichtbaren Satz kein Newsletter.
 *   Klaviyo beobachtet den Bestand und verschickt die Mail; Shop-Tools ist
 *   nicht beteiligt.
 * - Erfolg je Variante im localStorage: beim naechsten Besuch steht statt des
 *   Knopfs „Du bekommst Bescheid". Ist die Variante wieder lieferbar, faellt der
 *   Merker weg.
 * - Sonder-PDPs (running-pdp*, lifestyle-pdp): ihr Knopf [data-rp-notify] klickt
 *   den Notify-Me-Knopf im versteckten Formular, ohne ihn ruft er
 *   window.__runningNotify(variantId); ohne Variante (Kombination gibt es
 *   nicht) passiert nichts. Beides landet hier: Klicks auf den
 *   App-Knopf in einem Formular mit unserem Block fangen wir ab, solange die
 *   Einbettung noch an ist (Entwurf, Umstellungstag); fremde Formulare
 *   (Bundle-Studio) bleiben bei der App.
 * - Oeffentlich: window.aclRestock (open, subscribe, isSubscribed, forget, refresh).
 */
(function () {
  'use strict';

  if (window.aclRestock) {
    return;
  }

  var REVISION = '2026-10-15';
  var API = 'https://a.klaviyo.com/client/';
  var STORE_KEY = 'acl_restock_angemeldet'; // { "<Varianten-ID>": Zeitpunkt in ms }
  var ADDRESS_KEY = 'acl_restock_adresse'; // zuletzt benutzt, zum Vorbelegen
  var WISHLIST_ADDRESS_KEY = 'acl_wishlist_adresse'; // dieselbe Rolle in wishlist.js
  // So lange gilt „Du bekommst Bescheid". Klaviyo verbraucht die Anmeldung mit
  // der Mail; sieht der Browser den Nachschub nicht (Kundin kauft nicht, Groesse
  // wieder weg), faellt der Merker spaetestens hier und der Knopf kommt wieder.
  // Lieber kurz: ein Knopf zu viel schadet nicht (bestehende Anmeldung = 409 =
  // Erfolg), ein Hinweis ohne Anmeldung verspricht eine Mail, die nie kommt.
  var KEEP_MS = 14 * 24 * 60 * 60 * 1000;
  var MAX_STORED = 200;
  var MODAL_ID = 'AclRestockModal';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Element da, nicht hidden und gerendert (getClientRects leer = display:none)
  function visible(node) {
    if (!node || node.hidden) {
      return false;
    }
    return typeof node.getClientRects !== 'function' || node.getClientRects().length > 0;
  }

  function isEmail(value) {
    return EMAIL_RE.test(String(value || '').trim());
  }

  function parseJSON(text, fallback) {
    try {
      var value = JSON.parse(text);
      return value == null ? fallback : value;
    } catch (e) {
      return fallback;
    }
  }

  function has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function getStored(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null; // privater Modus: dann eben ohne Merker
    }
  }

  function setStored(key, value) {
    try {
      if (value == null) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, value);
      }
    } catch (e) {
      // siehe getStored
    }
  }

  /*---------- Gemerkte Anmeldungen ----------*/
  function subscriptions() {
    var data = parseJSON(getStored(STORE_KEY), {});
    if (typeof data !== 'object' || Array.isArray(data)) {
      data = {};
    }
    var now = Date.now();
    Object.keys(data).forEach(function (id) {
      if (!(now - data[id] < KEEP_MS)) {
        delete data[id];
      }
    });
    return data;
  }

  function isSubscribed(id) {
    return id != null && id !== '' && has(subscriptions(), String(id));
  }

  function remember(id) {
    var data = subscriptions();
    data[String(id)] = Date.now();
    var ids = Object.keys(data).sort(function (a, b) {
      return data[a] - data[b];
    });
    while (ids.length > MAX_STORED) {
      delete data[ids.shift()];
    }
    setStored(STORE_KEY, JSON.stringify(data));
  }

  function forget(id) {
    var data = subscriptions();
    if (has(data, String(id))) {
      delete data[String(id)];
      setStored(STORE_KEY, JSON.stringify(data));
    }
  }

  /*============================================================================
    Knopf am Produktformular
  ==============================================================================*/
  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-acl-restock]'));
  }

  function variantsOf(block) {
    if (!block._aclVariants) {
      block._aclVariants = parseJSON(block.getAttribute('data-variants'), {});
    }
    return block._aclVariants;
  }

  function render(block) {
    var id = block.getAttribute('data-variant-id') || '';
    var info = variantsOf(block)[id];
    var soldOut = !!info && !info[0];
    if (info && info[0]) {
      forget(id); // wieder lieferbar: Klaviyo hat die Anmeldung verbraucht
    }
    var subscribed = soldOut && isSubscribed(id);
    var open = block.querySelector('[data-acl-restock-open]');
    var note = block.querySelector('[data-acl-restock-subscribed]');
    block.hidden = !soldOut;
    if (open) {
      open.hidden = subscribed;
    }
    if (note) {
      note.hidden = !subscribed;
    }
    renderSpecial(block, note, subscribed);
  }

  // Sonder-PDPs: sichtbar ist deren Knopf [data-rp-notify] in .rp-cart, unser
  // Block steckt im versteckten Formular. Nach der Anmeldung steht dort statt
  // des Knopfs derselbe Hinweis; ein- und ausblenden per eigener Klasse, die
  // rp-hidden der Seite bleibt unberuehrt.
  function specialButton(block) {
    var holder = block && block.closest ? block.closest('[data-rp-form-holder]') : null;
    var root = holder ? holder.closest('[data-rp-root]') : null;
    return root ? root.querySelector('[data-rp-notify]') : null;
  }

  function renderSpecial(block, note, subscribed) {
    var rpBtn = specialButton(block);
    if (!rpBtn || !note) {
      return;
    }
    var rpNote = rpBtn.parentNode.querySelector('[data-acl-restock-rp-note]');
    if (!rpNote) {
      if (!subscribed) {
        return;
      }
      rpNote = note.cloneNode(true);
      rpNote.removeAttribute('data-acl-restock-subscribed');
      rpNote.setAttribute('data-acl-restock-rp-note', '');
      rpNote.classList.add('acl-restock__subscribed--rp');
      rpBtn.parentNode.insertBefore(rpNote, rpBtn.nextSibling);
    }
    rpBtn.classList.toggle('acl-restock-is-subscribed', subscribed);
    rpNote.hidden = !subscribed;
  }

  // Liefert false, wenn die Variante nicht zu diesem Produkt gehoert
  function setVariant(block, variant) {
    if (!variant) {
      block.setAttribute('data-variant-id', ''); // Kombination gibt es nicht
      render(block);
      return true;
    }
    var map = variantsOf(block);
    var key = String(variant.id);
    if (!has(map, key)) {
      return false;
    }
    if (typeof variant.available === 'boolean') {
      map[key][0] = variant.available ? 1 : 0;
    }
    block.setAttribute('data-variant-id', key);
    render(block);
    return true;
  }

  function init(block) {
    if (block._aclInit) {
      return;
    }
    block._aclInit = true;
    // theme.js meldet jeden Wechsel am Produkt-Container, auch ohne Variante
    var container = block.closest('[data-section-id][data-product-id]');
    if (container) {
      block._aclContainer = container;
      container.addEventListener('variantChange', function (evt) {
        setVariant(block, evt.detail ? evt.detail.variant : null);
      });
    }
    render(block);
  }

  function refresh() {
    blocks().forEach(function (block) {
      init(block);
      render(block);
    });
  }

  // Sonder-PDPs melden nur hier; setVariant uebergeht fremde Produkte
  function onDocumentVariant(evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) {
      return;
    }
    blocks().forEach(function (block) {
      setVariant(block, variant);
    });
  }

  document.addEventListener('variant:change', onDocumentVariant);
  document.addEventListener('variant:changed', onDocumentVariant);

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-acl-restock-open]');
    if (!btn) {
      return;
    }
    var block = btn.closest('[data-acl-restock]');
    if (block) {
      evt.preventDefault();
      open(block.getAttribute('data-variant-id'), btn, block);
    }
  });

  // Notify-Me-Knopf im Produktformular → unser Dialog (Capture, damit die App
  // den Klick nicht mehr bekommt). Die Sonder-PDPs setzen vorher die Auswahl im
  // Formular; ausverkaufte Varianten haben dort keinen Wert, dann gilt die
  // Variante des Blocks (per variant:changed nachgefuehrt).
  document.addEventListener('click', function (evt) {
    var appBtn = evt.target && evt.target.closest ? evt.target.closest('.restock-alerts-notify-button') : null;
    var form = appBtn ? appBtn.closest('form') : null;
    var block = form ? form.querySelector('[data-acl-restock]') : null;
    if (!block) {
      return;
    }
    var select = form.querySelector('[name="id"]');
    // Fokus-Quelle: der sichtbare Knopf der Sonder-PDP (der App-Knopf steckt im
    // versteckten Formular), sonst der App-Knopf selbst – nicht
    // document.activeElement, Safari fokussiert Knoepfe beim Klick nicht
    var source = specialButton(block) || appBtn;
    if (open(select && select.value ? select.value : null, source, block)) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
  }, true);

  /*============================================================================
    Dialog
  ==============================================================================*/
  var modal = null;
  var current = null; // { variantId, label }
  var lastFocus = null;
  var sending = false;

  function ensureModal() {
    if (modal) {
      return modal;
    }
    var tpl = document.querySelector('template[data-acl-restock-template]');
    var source = tpl && tpl.content ? tpl.content.firstElementChild : null;
    if (!source) {
      return null;
    }
    var el = source.cloneNode(true);
    el.id = MODAL_ID;
    document.body.appendChild(el);

    var q = function (name) {
      return el.querySelector('[data-acl-restock-' + name + ']');
    };
    modal = {
      el: el,
      formStep: el.querySelector('[data-acl-restock-step="form"]'),
      doneStep: el.querySelector('[data-acl-restock-step="done"]'),
      product: q('product'),
      form: q('form'),
      email: q('email'),
      honeypot: q('hp'),
      newsletter: q('newsletter'),
      submit: q('submit'),
      error: q('error'),
      doneTitle: q('done-title'),
      doneText: q('done-text'),
      doneMarketing: q('done-marketing'),
      ctrl: null
    };
    modal.submitText = modal.submit ? modal.submit.textContent : '';

    if (window.theme && theme.Modals) {
      var ctrl = new theme.Modals(MODAL_ID, 'acl-restock', { focusIdOnOpen: modal.email ? modal.email.id : null });
      modal.ctrl = ctrl && ctrl.modal ? ctrl : null;
    }
    if (!modal.ctrl) {
      // Ohne Theme-Code: schlicht ein- und ausblenden
      el.querySelectorAll('.js-modal-close').forEach(function (btn) {
        btn.addEventListener('click', closeFallback);
      });
    }

    modal.form.addEventListener('submit', onSubmit);
    modal.email.addEventListener('input', function () {
      modal.email.removeAttribute('aria-invalid');
    });
    document.addEventListener('modalClose.' + MODAL_ID, onClosed);
    return modal;
  }

  // document.activeElement, aber nie der Body (Safari: kein Fokus auf Knoepfen)
  function focusedElement() {
    var el = document.activeElement;
    return el && el !== document.body ? el : null;
  }

  function closeFallback() {
    if (modal && modal.el.classList.contains('modal--is-active')) {
      modal.el.classList.remove('modal--is-active');
      document.documentElement.classList.remove('modal-open');
      onClosed();
    }
  }

  // Nach der Anmeldung ist der Knopf ausgeblendet: dann der Hinweis an seiner
  // Stelle – im Block oder, auf Sonder-PDPs, neben deren Knopf
  function focusTarget(target) {
    if (!target || !target.closest) {
      return target;
    }
    var block = target.closest('[data-acl-restock]');
    var note = block ? block.querySelector('[data-acl-restock-subscribed]') : null;
    if (note && !note.hidden && target.hidden) {
      note.setAttribute('tabindex', '-1');
      return note;
    }
    if (target.hasAttribute('data-rp-notify') && target.classList.contains('acl-restock-is-subscribed') && target.parentNode) {
      var rpNote = target.parentNode.querySelector('[data-acl-restock-rp-note]');
      if (rpNote && !rpNote.hidden) {
        rpNote.setAttribute('tabindex', '-1');
        return rpNote;
      }
    }
    return target;
  }

  function onClosed() {
    var target = focusTarget(lastFocus);
    lastFocus = null;
    if (target && document.contains(target) && target.offsetParent !== null) {
      // theme.js nimmt beim Schliessen den Fokus weg; danach zurueck zum Knopf.
      // Liegt er ausserhalb des Fensters (Sticky-Leiste am Handy), ohne Sprung.
      setTimeout(function () {
        var rect = target.getBoundingClientRect ? target.getBoundingClientRect() : null;
        var inView = !rect || (rect.bottom > 0 && rect.top < (window.innerHeight || 0));
        try {
          target.focus(inView ? undefined : { preventScroll: true });
        } catch (e) {
          target.focus();
        }
      }, 0);
    }
  }

  // Adresse vorbelegen: angemeldeter Kunde (steht schon im Feld), zuletzt hier
  // oder auf der Wunschliste benutzt, sonst die aus Klaviyos Cookie __kla_id
  function suggestedAddress() {
    var stored = [getStored(ADDRESS_KEY), getStored(WISHLIST_ADDRESS_KEY)];
    for (var i = 0; i < stored.length; i++) {
      if (isEmail(stored[i])) {
        return String(stored[i]).trim();
      }
    }
    try {
      var match = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      var data = match ? JSON.parse(window.atob(decodeURIComponent(match[1]))) : null;
      if (data && isEmail(data.$email)) {
        return String(data.$email).trim();
      }
    } catch (e) {
      // Cookie fehlt oder hat ein anderes Format
    }
    return '';
  }

  // Variante und Bezeichnung; ohne ID die gewaehlte des Blocks. Nur fuer
  // ausverkaufte Varianten – fuer lieferbare gibt es nichts anzumelden.
  function lookup(variantId, onlyBlock) {
    var list = onlyBlock ? [onlyBlock] : blocks();
    for (var i = 0; i < list.length; i++) {
      var block = list[i];
      var map = variantsOf(block);
      var id = variantId != null && variantId !== '' ? String(variantId) : block.getAttribute('data-variant-id');
      if (id && has(map, id)) {
        if (map[id][0]) {
          return null;
        }
        var title = block.getAttribute('data-product-title') || '';
        var variantTitle = map[id][1];
        var single = block.hasAttribute('data-single') || !variantTitle;
        return { variantId: id, label: single ? title : title + ' – ' + variantTitle };
      }
    }
    return null;
  }

  function showStep(step) {
    modal.formStep.hidden = step !== 'form';
    modal.doneStep.hidden = step !== 'done';
  }

  function setSending(on) {
    sending = on;
    modal.submit.disabled = on;
    modal.submit.textContent = on ? (modal.submit.getAttribute('data-text-sending') || modal.submitText) : modal.submitText;
    modal.form.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showError(kind) {
    if (!kind) {
      modal.error.hidden = true;
      modal.error.textContent = '';
      modal.email.removeAttribute('aria-invalid');
      return;
    }
    modal.error.textContent = modal.error.getAttribute(kind === 'invalid' ? 'data-text-invalid' : 'data-text-error') || '';
    modal.error.hidden = false;
    if (kind === 'invalid') {
      modal.email.setAttribute('aria-invalid', 'true');
    }
  }

  function open(variantId, source, block) {
    var info = lookup(variantId, block || null);
    if (!info || !ensureModal()) {
      return false;
    }
    current = info;
    lastFocus = source || focusedElement();
    modal.product.textContent = info.label;
    showStep('form');
    showError(null);
    setSending(false);
    modal.honeypot.value = '';
    if (!modal.email.value) {
      modal.email.value = suggestedAddress();
    }
    if (modal.ctrl) {
      modal.ctrl.open();
    } else {
      modal.el.classList.add('modal--is-active');
      document.documentElement.classList.add('modal-open');
      modal.email.focus();
    }
    return true;
  }

  // newsletter: Klaviyo hat die Newsletter-Anmeldung angenommen; sonst nur der
  // normale Erfolgstext
  function finish(newsletter) {
    var text = modal.doneText.getAttribute('data-text') || '';
    modal.doneText.textContent = text.replace('[product]', function () { return current.label; }); // Funktion: „$&" im Produktnamen bleibt, wie er ist
    modal.doneMarketing.hidden = !newsletter;
    showStep('done');
    setSending(false);
    setTimeout(function () {
      modal.doneTitle.focus();
    }, 50);
  }

  function onSubmit(evt) {
    evt.preventDefault();
    if (sending || !current) {
      return;
    }
    var address = modal.email.value.trim();
    if (!isEmail(address)) {
      showError('invalid');
      modal.email.focus();
      return;
    }
    // Newsletter nur, wenn der Hinweis ueber dem Knopf zu sehen war
    // (auch nicht per Custom-CSS weggeblendet)
    var marketing = visible(modal.newsletter);
    showError(null);
    if (modal.honeypot.value) {
      finish(false); // Bot: so tun, als waere alles gut, nichts senden
      return;
    }
    setSending(true);
    var info = current;
    subscribe(address, info.variantId, marketing).then(function (outcome) {
      var newsletter = !!(outcome && outcome.newsletter);
      setStored(ADDRESS_KEY, address);
      remember(info.variantId);
      refresh();
      document.dispatchEvent(new CustomEvent('restock:subscribed', {
        detail: { variantId: info.variantId, newsletter: newsletter }
      }));
      finish(newsletter);
    }, function (err) {
      setSending(false);
      showError(err && err.invalidEmail ? 'invalid' : 'error');
    });
  }

  /*============================================================================
    Klaviyo Client-API (oeffentlicher Schluessel, kein Geheimnis im Browser)
  ==============================================================================*/
  // Schluessel aus der Theme-Einstellung, sonst aus der Klaviyo-Einbettung der
  // Seite (static.klaviyo.com/onsite/js/<id>/…), wie in wishlist.js
  function config() {
    var el = modal ? modal.el : document.querySelector('[data-acl-restock-modal]');
    var company = el ? String(el.getAttribute('data-company') || '').trim() : '';
    if (!company) {
      var script = document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]');
      var src = script ? script.getAttribute('src') : '';
      var match = /company_id=([A-Za-z0-9]+)/.exec(src) || /onsite\/js\/([A-Za-z0-9]+)\//.exec(src);
      company = match ? match[1] : '';
    }
    var locale = el ? el.getAttribute('data-locale') : '';
    return {
      company: company,
      list: el ? String(el.getAttribute('data-list') || '').trim() : '',
      // wie wishlist.js: der Sprachcode des Shops (de, en, es, fr, nl …)
      sprache: String(locale || document.documentElement.lang || 'de').slice(0, 5)
    };
  }

  function post(path, company, body) {
    return fetch(API + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(body)
    });
  }

  function mentionsEmail(data) {
    var errors = data && Array.isArray(data.errors) ? data.errors : [];
    return errors.some(function (error) {
      var pointer = error && error.source && error.source.pointer ? error.source.pointer : '';
      return /email/i.test(pointer) || /email/i.test(String((error && error.detail) || ''));
    });
  }

  // Fuer client/profiles und die Newsletter-Anmeldung. `locale` (nur zwei
  // Buchstaben, s. wishlist.js klaviyoLocale) waehlt Klaviyos Uebersetzungen;
  // nicht im Aufruf an back-in-stock-subscriptions, dort ist es nicht belegt.
  function profileBody(address, cfg, withConsent) {
    var attributes = {
      email: address,
      locale: String(cfg.sprache).slice(0, 2).toLowerCase(),
      properties: { sprache: cfg.sprache }
    };
    if (withConsent) {
      attributes.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    }
    return { data: { type: 'profile', attributes: attributes } };
  }

  // Erfuellt sich mit { newsletter } , wenn Klaviyo die Anmeldung angenommen hat
  // (202; 409 = gibt es schon, fuer den Kunden dasselbe). Sprache und Newsletter
  // folgen danach, deren Fehler bleiben still; ob der Newsletter angenommen
  // wurde, steht im Ergebnis.
  function subscribe(address, variantId, marketing) {
    var cfg = config();
    if (!cfg.company) {
      return Promise.reject({ config: true });
    }
    var body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: address } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    };
    return post('back-in-stock-subscriptions', cfg.company, body).then(function (response) {
      if (response.ok || response.status === 409) {
        return true;
      }
      return response.json().catch(function () {
        return null;
      }).then(function (data) {
        throw { status: response.status, invalidEmail: response.status === 400 && mentionsEmail(data) };
      });
    }, function () {
      throw { network: true };
    }).then(function () {
      var calls = [post('profiles', cfg.company, profileBody(address, cfg, false))];
      if (marketing && cfg.list) {
        var subscription = profileBody(address, cfg, true);
        calls.push(post('subscriptions', cfg.company, {
          data: {
            type: 'subscription',
            attributes: { custom_source: 'Back2Stock', profile: subscription },
            relationships: { list: { data: { type: 'list', id: cfg.list } } }
          }
        }));
      }
      return Promise.all(calls.map(function (call) {
        return call.then(function (response) {
          return !!(response && (response.ok || response.status === 409));
        }, function () {
          return false; // Beiwerk, die Anmeldung steht schon
        });
      }));
    }).then(function (results) {
      return { newsletter: results.length > 1 && results[1] === true };
    });
  }

  /*============================================================================
    Start
  ==============================================================================*/
  // Sonder-PDPs: ohne Variante (Kombination gibt es nicht) nichts tun, sonst
  // laege der Rueckfall auf data-variant-id des Blocks bei einer anderen
  // Variante. Fokus-Quelle ist deren sichtbarer Knopf (Safari fokussiert
  // Knoepfe beim Klick nicht, document.activeElement waere der Body).
  window.__runningNotify = function (variantId) {
    if (variantId == null || variantId === '') {
      return;
    }
    var source = document.querySelector('[data-rp-root] [data-rp-notify]:not(.rp-hidden)');
    open(variantId, source || null);
  };

  window.aclRestock = {
    open: open,
    subscribe: subscribe,
    isSubscribed: isSubscribed,
    forget: forget,
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  // Zurueck-Knopf (bfcache): Merker koennen sich in einem anderen Tab geaendert haben
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) {
      refresh();
    }
  });
})();
